import { Patient, Practitioner } from '@medplum/fhirtypes';
import { formatHumanName } from '@medplum/core';
import { ANSWER_DELIVERY_OPTIONS } from '../constants/deliveryOptions';
import { ARKON, IDENTIFIERS } from '@/consts/systems.consts';

export function formatDate(dateString?: string): string {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('el-GR');
}

export function getPatientOrPractitionerName(
  entity?: Patient | Practitioner
): string {
  if (!entity) {
    return 'N/A';
  }

  const entityType = entity.resourceType;
  if (entityType !== 'Patient' && entityType !== 'Practitioner') {
    return 'N/A';
  }

  const formattedName = formatHumanName(entity.name?.[0]);
  return formattedName || `Unknown ${entityType}`;
}

export function getPatientAmka(patient: Patient): string {
  return (
    patient.identifier?.find((id) => id.system === IDENTIFIERS.AMKA)?.value ||
    ''
  );
}

export function getAnswerDeliveryDisplayName(value: string | string[]): string {
  const values = Array.isArray(value) ? value : value ? [value] : [];
  const labels = values.map(
    (v) => ANSWER_DELIVERY_OPTIONS.find((d) => d.value === v)?.label || v
  );
  return labels.filter(Boolean).join(', ') || '-';
}

export function hasAuthorizedPerson(value: string | string[]): boolean {
  const values = Array.isArray(value) ? value : value ? [value] : [];
  return values.includes(ARKON.CS.DELIVERY.METHODS.CODES.AUTHORIZED_PERSON);
}
